import { LinearProgress } from '@mui/material'
import { useIsFetching, useIsMutating } from '@tanstack/react-query'

const GlobalLoadingIndicator = () => {
  const fetching = useIsFetching()
  const mutating = useIsMutating()
  const active = fetching > 0 || mutating > 0

  return (
    <LinearProgress
      data-testid="global-loading-indicator"
      data-loading={active ? 'true' : 'false'}
      color="secondary"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.tooltip + 1,
        height: 3,
        backgroundColor: 'transparent',
        visibility: active ? 'visible' : 'hidden',
        '& .MuiLinearProgress-bar': {
          boxShadow: (theme) => `0 0 10px ${theme.palette.secondary.main}, 0 0 5px ${theme.palette.secondary.main}`,
        },
      }}
    />
  )
}

export default GlobalLoadingIndicator
